import {initJumpmarks} from "./jumpmark";
import {focusInputGroups} from "./checkInputGroups";
import {hideMobileMenu, showMobileMenu} from "./mobileMenu";
import {generateMuteButton, setSrcVideos} from "./video";
import {testimonials} from "./testimonials";
import {accordion} from "./accordion";
import {clickFormItem} from "./clickFormItem";
import {initDatepickers} from "./datepicker";

function stickyHeader(header){
    if(window.scrollY > header.clientHeight){
        header.classList.add("sticky");
    }else{
        header.classList.remove("sticky");
    }
}

window.onload = function (){
    const header = document.getElementById("header");
    const mobileMenu = document.querySelector('.mobileMenu');
    const mobileMenuToggle = document.getElementById("js-toggleNavigation");
    const overlay = document.getElementById("overlay");

    if (mobileMenu && mobileMenuToggle && overlay) {
        const mobileMenuClose = mobileMenu.querySelector(".mobileMenu__close");

        mobileMenuToggle.addEventListener("click", function () {
            if(mobileMenuToggle.classList.contains("is-active")){
                hideMobileMenu(mobileMenu, overlay, mobileMenuToggle);
            }else{
                showMobileMenu(mobileMenu, overlay, mobileMenuToggle);
            }
        })

        mobileMenuClose.addEventListener("click", function () {
            hideMobileMenu(mobileMenu, overlay, mobileMenuToggle);
        });

        overlay.addEventListener("click", function () {
            hideMobileMenu(mobileMenu, overlay, mobileMenuToggle);
        });


        for(let link of mobileMenu.querySelectorAll('.menu a')){
            link.addEventListener("click",function (){
                hideMobileMenu(mobileMenu, overlay, mobileMenuToggle);
            });
        }
    }

    if(!document.body.classList.contains("body_home")){
        for(let link of document.querySelectorAll('#navigation a')){
            link.addEventListener("click",function (){
                location.href = "/"+link.getAttribute("href");
            });
        }
    }

    stickyHeader(header);
    window.addEventListener("scroll", function (e) {
        stickyHeader(header);
    });

    let offsetTopJumpmarks = 0;
    if (header) {
        offsetTopJumpmarks = header.clientHeight;
    }
    initJumpmarks(offsetTopJumpmarks);

    /*for(let wpcfCheckbox of document.querySelectorAll(".wpcf7-list-item")){
        wpcfCheckbox.addEventListener("click",function (){
            if(wpcfCheckbox.classList.contains("active")){
                wpcfCheckbox.classList.remove("active");
                wpcfCheckbox.querySelector("input").checked = false;
            }else{
                wpcfCheckbox.classList.add("active");
                wpcfCheckbox.querySelector("input").checked = true;
            }
        });
    }*/

    //focusInputGroups();

    /*for(let video of document.querySelectorAll(".mbBanner video")){
        generateMuteButton(video);
    }*/
    //setSrcVideos();

    //testimonials();

    //accordion();

    //clickFormItem();

    //initDatepickers();
}